import script from "./MarketingMain.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingMain.vue?vue&type=script&setup=true&lang=js"

import "./MarketingMain.vue?vue&type=style&index=0&id=1cf5c539&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf5c539"]])

export default __exports__